module.exports = __webpack_public_path__ + "img/img-isfp.dce40e65.jpg";